import React from 'react';
import { Link } from "react-router-dom";

import megaLogo from '../assets/img/megago.svg';
import { Icons } from '../utils/Icons';

export const Header = () => {

  return (
    <div className="mainLogo">
      <a href="https://megago.cl">
        <Icons path={megaLogo} />
      </a>
      <i></i>
      <Link to="/">
        <h1>Centro de ayuda</h1>
      </Link>
    </div>
  )
}
